module.exports = __webpack_public_path__ + "img/zimmer-frei-4.eef33a6a.jpg";